// Problem Reporter — recent network-failure ring buffer.
//
// apiFetch (lib/api.ts) records here on any non-2xx response or thrown network error. Bounded
// (~30 entries) so it can't grow without bound. getNetworkFails() snapshots it for a report.
// Kept separate from consoleBuffer so api.ts depends on a tiny module, not the console patch.

export interface NetworkFail {
  t: string;       // ISO timestamp
  method: string;
  path: string;
  status: number;  // HTTP status, or 0 for a network-level throw (server unreachable)
  ms: number;      // elapsed ms
}

const MAX_ENTRIES = 30;
const buffer: NetworkFail[] = [];

export function recordNetworkFail(fail: NetworkFail): void {
  buffer.push(fail);
  if (buffer.length > MAX_ENTRIES) buffer.shift();
}

/** Snapshot of recent network failures for a problem report. */
export function getNetworkFails(): NetworkFail[] {
  return buffer.slice();
}
